/**
 * Helper function to handle common animation toggle logic
 */
export const handleAnimationToggle = ({
  shouldReverse,
  setToggleState,
  setOtherToggleState,
  setSelectedMeshName: setMeshName,
  productSettings,
  animationDirection,
  setAnimationDirection,
  animationPlaying,
  setAnimationPlaying,
  setOrbitControlsEnabled,
  orbitControlsEnabled,
  setShowLabels,
  setDisableLabels,
}) => {
  if (productSettings.reversibleAnimation) {
    if (shouldReverse) {
      setAnimationDirection(-animationDirection);
      setToggleState(-animationDirection > 0 ? true : false);
    } else {
      setAnimationDirection(1);
      setToggleState(true);
    }
  } else {
    setToggleState(!animationPlaying);
  }

  // Common state updates
  setAnimationPlaying(!animationPlaying);
  setOrbitControlsEnabled(!orbitControlsEnabled);
  setShowLabels(false);
  setDisableLabels(!animationPlaying);

  // Optional cleanup functions
  if (setMeshName) setMeshName(null);
  if (setOtherToggleState) setOtherToggleState(false);
};
